// TODO refactor to using emotion themes

export const lightGray = '#f5f5f5';
export const activeColor = '#d9eeff';
export const borderColor = '#e7e2de';

export const neg = '#e60000';
export const pos = '#008A00';
export const flat = '#555555';
